import {useContext, useMemo} from 'react';
import {BoostrapDataContext} from '../core/bootstrap-data/bootstrap-data-context';
import {getLocalTimeZone} from '@internationalized/date';

export function useUserTimezone(): string {
  const {data} = useContext(BoostrapDataContext);
  const user = data?.user;
  const defaultTimezone = data?.settings?.dates?.default_timezone;
  const preferredTimezone = user?.timezone || defaultTimezone || 'auto';

  return useMemo(() => {
    return !preferredTimezone || preferredTimezone === 'auto'
      ? getLocalTimeZone()
      : preferredTimezone;
  }, [preferredTimezone]);
}
